export class AppConfig {

  public static mailUrl = 'https://backend.mspforafrica.com/contact';

}
